import { Button, Collapse } from "@blueprintjs/core"
import React from "react"
import clsx from "utils/clsx"
import { RuleStrType } from "."
import CustomButton from "../CustomButton"
import CustomCheckbox from "../CustomCheckbox"

export type RuleWrapperType = {
  ruleType?: RuleStrType
  onDelete?: (index) => void
  index: number
  isOpen?: boolean
  onOpen?: (index?: number) => void
  onTypeChange?: (type: RuleStrType) => void
  children?: React.ReactNode
  title?: string
}
const RuleWrapper = ({
  ruleType,
  index,
  onDelete,
  isOpen,
  onOpen,
  onTypeChange,
  children,
  title,
}: RuleWrapperType) => {
  const exclude = ruleType?.startsWith("EX")

  return (
    <>
      <div
        onClick={() => onOpen(index)}
        style={{
          borderBottom: "1px solid #dee2e6",
        }}
        className={clsx(
          "p-2 cursor-pointer hover:opacity-90 text-gray-800 font-500 flex justify-between",
          exclude ? "bg-red-50" : "bg-green-50"
        )}
      >
        <div className="flex items-center">
          <Button
            className="mr-2"
            minimal
            icon={isOpen ? "chevron-down" : "chevron-up"}
          />
          <p className="m-0">
            {exclude ? "excluding , " : null} {title}
          </p>
        </div>
        {onDelete && isOpen && (
          <CustomButton
            intent="danger"
            outlined
            text={"remove rule"}
            onClick={e => {
              e.preventDefault()
              onDelete?.(index)
            }}
            small
            icon="cross"
          />
        )}
      </div>
      <Collapse isOpen={isOpen}>
        <div
          className="p-3 text-gray-700"
          style={{
            borderBottom: "1px solid #dee2e6",
          }}
        >
          <div>
            <CustomCheckbox
              onChange={() => {
                if (exclude) {
                  onTypeChange(ruleType?.includes("RULE") ? "RRULE" : "RDATE")
                } else {
                  onTypeChange(ruleType?.includes("RULE") ? "EXRULE" : "EXDATE")
                }
              }}
              checked={exclude}
              label="Exclude this rule"
            />
          </div>
          {children}
        </div>
      </Collapse>
    </>
  )
}

export default RuleWrapper
